import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@/lib/utils"

const Tabs = TabsPrimitive.Root

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "flex w-full flex-col items-stretch gap-3 p-2 text-muted-foreground md:flex-row md:flex-wrap md:items-center md:justify-start",
      className
    )}
    {...props}
  />
))
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "group relative flex w-full items-center justify-between gap-3 rounded-2xl border border-sky-100/80 bg-white px-5 py-4 text-left text-sm font-semibold text-slate-600 ring-offset-background transition-all duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400/60 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-40 md:inline-flex md:min-w-[8rem] md:flex-1 md:basis-[12rem] md:justify-between data-[state=active]:border-sky-400 data-[state=active]:bg-sky-50 data-[state=active]:text-sky-700 data-[state=active]:shadow-lg data-[state=inactive]:hover:border-sky-200 data-[state=inactive]:hover:bg-sky-50/70 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-200 dark:data-[state=active]:border-sky-500 dark:data-[state=active]:bg-sky-900/50 dark:data-[state=active]:text-sky-200 dark:data-[state=inactive]:hover:bg-slate-800",
      className
    )}
    {...props}
  />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-4 rounded-2xl border border-sky-100/80 bg-white p-4 shadow-lg ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400/45 focus-visible:ring-offset-2 sm:p-5 md:p-6 dark:border-slate-800 dark:bg-slate-950/70",
      className
    )}
    {...props}
  />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent }
